export enum storageKey {
  'a' = 'a'
}
export enum sessionKey {
  'user_token' = 'user.token'
}

export function setLocalData (key: storageKey, value: string) {
  if (window.localStorage) {
    try {
      window.localStorage.setItem(key, value)
    } catch {}
  }
}

export function getLocalData (key: storageKey) {
  if (window.localStorage) {
    try {
      return window.localStorage.getItem(key)
    } catch {
      return ''
    }
  }
}

export function setSessionData (key: sessionKey, value: string) {
  if (window.sessionStorage) {
    try {
      return window.sessionStorage.setItem(key, value)
    } catch {
      return ''
    }
  }
}

export function getSessionData (key: sessionKey) {
  if (window.sessionStorage) {
    try {
      return window.sessionStorage.getItem(key)
    } catch {
      return ''
    }
  }
}
